export enum EPeriodosBusca {
	DIARIO = 31,
	MENSAL = 12,
	ANUAL = 10,
	ANO_EM_DIAS = 365,
}
